/* eslint-disable react/prop-types */
import { Toast, ToastMessage } from 'primereact/toast';
import { useMemo, useRef, useState } from 'react';

import { NOTIFICATION_ICONS } from '../../shared/constants/notification-icons.constant';
import { INotificationContext } from '../../shared/interfaces/INotificationContext';
import NotificationContext from './NotificationContext';

type NotificationProviderProps = {
  children: React.ReactNode;
};

const NotificationProvider = ({ children }: NotificationProviderProps): JSX.Element => {
  const toastRef = useRef<Toast>(null);

  const [isNewNotification, setIsNewNotification] = useState<boolean>(false);

  const notify = (props: ToastMessage): void => {
    if (toastRef.current) {
      toastRef.current.show({
        ...props,
        icon: (
          <i
            className={`pi pi-${
              NOTIFICATION_ICONS[props?.severity ?? 'info']
            } p-notification-custom-icon ${props.severity}-background text-white	`}
          />
        ),
        sticky: !props.life,
      });
    }
  };

  // To remove a specific toast message
  const remove = (toastMessage: ToastMessage): void => {
    if (toastRef.current) {
      toastRef.current.remove(toastMessage);
    }
  };

  // To remove all toast messages
  const clear = (): void => {
    if (toastRef.current) {
      toastRef.current.clear();
    }
  };

  const state = useMemo<INotificationContext>(() => {
    return { notify, remove, clear, toastRef, isNewNotification, setIsNewNotification };
  }, [notify, remove, clear, toastRef, isNewNotification, setIsNewNotification]);

  return (
    <NotificationContext.Provider value={state}>
      <Toast ref={toastRef} />
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
